import { render, staticRenderFns } from "./ReferFriend.vue?vue&type=template&id=1ea12fce&scoped=true&"
import script from "./ReferFriend.vue?vue&type=script&lang=js&"
export * from "./ReferFriend.vue?vue&type=script&lang=js&"
import style0 from "./ReferFriend.vue?vue&type=style&index=0&id=1ea12fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea12fce",
  null
  
)

export default component.exports